// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"284":"cdef6ab8","975":"0b6b6593"}[chunkId] + ".chunk.css";
};